export function setClasses(cls, classes) {
  return cls.map(c => classes[c]).filter(Boolean).join(' ');
}
